const Container = ({ children, className = '' }) => (
  <div className={`w-full max-w-[1480px] mx-auto px-6 md:px-4 ${className}`}>
    {children}
  </div>
);

export default Container;
